export default __webpack_public_path__ + "static/media/smallbanners_Motilal-Oswal-Flexicap-Fund.03b9b9ce.jpg";